// ServerMaintenance.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MaintenanceImage from "../images/maintenance.svg";
import { unifiedPageUrl } from "../services/axiosConfig";

const ServerMaintenance = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check sessionStorage to allow access
    if (!sessionStorage.getItem("backendFailed")) {
      // If accessed directly, redirect to home
      navigate("/edetail-manager");
    } else {
      // Clear flag so page refresh doesn't bypass check
      sessionStorage.removeItem("backendFailed");
    }
  }, [navigate]);

  const handleButtonClick = () => {
    window.open(unifiedPageUrl, "_self");
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <div style={styles.innerContainer}>
          <div style={styles.illustration}>
            <img src={MaintenanceImage} alt="" />
          </div>
          <div style={styles.content}>
            <h1 style={styles.heading}>We are under maintenance.</h1>
            <p style={styles.message}>
              We're currently performing maintenance to improve your experience.
              We expect to be back online shortly. We appreciate your
              understanding.
            </p>
            <p style={styles.supportInfo}>
              Contact Content Studio SPOC for urgent support.
            </p>
            <button style={styles.button} onClick={handleButtonClick}>
              Go to Landing Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Inline styles converted from your HTML <style> block
const styles = {
  body: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
    backgroundColor: "#ffffff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    padding: "20px",
  },
  container: {
    width: "700px",
    height: "479px",
    padding: "40px",
    backgroundColor: "#ffffff",
  },
  innerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "30px",
  },
  illustration: {
    width: "100%",
    maxWidth: "318px",
    height: "auto",
    marginBottom: "10px",
    textAlign: "center",
  },
  content: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    width: "100%",
  },
  heading: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#203662",
    margin: 0,
  },
  message: {
    fontSize: "16px",
    color: "#1e1e1e",
    lineHeight: 1.6,
    margin: 0,
    fontWeight: 600,
  },
  supportInfo: {
    fontSize: "16px",
    color: "#878888",
    margin: 0,
  },
  button: {
    backgroundColor: "#203662",
    color: "#ffffff",
    border: "none",
    width: "140px",
    height: "32px",
    fontSize: "12px",
    borderRadius: "16px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    marginTop: "10px",
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default ServerMaintenance;
